module.exports = __webpack_public_path__ + "img/nr-logo.2eac1d56.png";